import { useGetEprgUrl } from './useGetEprgUrl';

export const useWellmedService = () => {
    const getEprgUrl = useGetEprgUrl();

    return {
        getEprgUrl,
    };
};
